import { CmsApiFourArticlesHighlightBlockData } from 'modules/cms/api/types/CmsApiFourArticlesHighlight';
import { CmsBlockWidth } from 'modules/cms/api/types/CmsBlockWidth';
import { CmsBlockMapping } from 'modules/cms/blocks/CmsBlockMapping';

import { CmsAmpFourArticlesHighlightBlock } from './CmsAmpFourArticlesHighlightBlock';
import { CmsFourArticlesHighlightBlock } from './CmsFourArticlesHighlightBlock';

export const CmsFourArticlesHighlightBlockMapping: CmsBlockMapping<CmsApiFourArticlesHighlightBlockData> =
  {
    invariant: [],
    width: CmsBlockWidth.GRID,
    Component: CmsFourArticlesHighlightBlock,
    AmpComponent: CmsAmpFourArticlesHighlightBlock,
  };
